import { type EventArea, logUsage } from "owa-analytics";
import { checkMaxEventsPerSessionCount } from "owa-analytics-utils/lib/checkMaxEventsPerSessionCount";
import type { MailboxInfo } from "owa-client-types";
import { getGrowthTelemetryData } from "owa-growth-telemetry";
import { getMicrosoft365UpsellDimeConfig, getMicrosoft365UpsellMode, isMicrosoft365UpgradeMode, } from "./getMicrosoft365UpsellMode";

function getPersistentHeaderButtonTelemetryData(mailboxInfo: MailboxInfo, action: "EntryPointShown" | "EntryPointHovered") {
    const upsellMode = getMicrosoft365UpsellMode(mailboxInfo);
    const dimeConfig = getMicrosoft365UpsellDimeConfig(mailboxInfo);
    if (upsellMode === "hidden" || !dimeConfig) {
        return getGrowthTelemetryData({
            Scenario: "Microsoft365Upsell",
            Action: action,
            EntryPoint: "AppHeader",
            PartnerId: "OutlookOwa",
        }, { IsUpgrade: false });
    }
    
    return getGrowthTelemetryData({
        Scenario: "Microsoft365Upsell",
        Action: action,
        EntryPoint: "AppHeader",
        PartnerId: "OutlookOwa",
        CmmId: dimeConfig.campaignId,
    }, {
        IsUpgrade: isMicrosoft365UpgradeMode(upsellMode),
        ...(dimeConfig.featureName ? { FeatureName: dimeConfig.featureName } : undefined),
    });
}

export function logPersistentHeaderButtonShown(mailboxInfo: MailboxInfo): void {
    if (!checkMaxEventsPerSessionCount("HeaderBuyMicrosoft365ButtonShown", 1)) {
        return;
    }
    
    logUsage("HeaderBuyMicrosoft365ButtonShown", mailboxInfo, getPersistentHeaderButtonTelemetryData(mailboxInfo, "EntryPointShown"), { eventArea: "GrowthStandardTelemetry" });
}

export function logPersistentHeaderButtonHovered(mailboxInfo: MailboxInfo): void {
    logUsage("HeaderBuyMicrosoft365ButtonHovered", mailboxInfo, getPersistentHeaderButtonTelemetryData(mailboxInfo, "EntryPointHovered"), { eventArea: "GrowthStandardTelemetry" });
}
